"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconCodes = void 0;
// This file is automatically generated. Do not edit or commit.
// tslint:disable object-literal-sort-keys
exports.IconCodes = {
    'hc-icon--badge': '\e970',
    'hc-icon--control-accordion-close': '\e900',
    'hc-icon--control-accordion-open': '\e901',
    'hc-icon--control-bills': '\e902',
    'hc-icon--control-bills-past': '\e903',
    'hc-icon--control-calendar': '\e904',
    'hc-icon--control-chevron-forward': '\e905',
    'hc-icon--control-close': '\e906',
    'hc-icon--control-contact': '\e907',
    'hc-icon--control-delete': '\e908',
    'hc-icon--control-edit': '\e909',
    'hc-icon--control-email': '\e90a',
    'hc-icon--control-feedback': '\e90b',
    'hc-icon--control-file-download': '\e90c',
    'hc-icon--control-file-upload': '\e90d',
    'hc-icon--control-help': '\e90e',
    'hc-icon--control-item-add': '\e90f',
    'hc-icon--control-item-remove': '\e910',
    'hc-icon--control-keyboard': '\e911',
    'hc-icon--control-link-out': '\e912',
    'hc-icon--control-location': '\e913',
    'hc-icon--control-log-off': '\e914',
    'hc-icon--control-log-on': '\e915',
    'hc-icon--control-manage': '\e916',
    'hc-icon--control-more': '\e917',
    'hc-icon--control-page-down': '\e918',
    'hc-icon--control-page-up': '\e919',
    'hc-icon--control-pin': '\e91a',
    'hc-icon--control-print': '\e91b',
    'hc-icon--control-recurring': '\e91c',
    'hc-icon--control-refresh': '\e91d',
    'hc-icon--control-reminder': '\e91e',
    'hc-icon--control-search': '\e91f',
    'hc-icon--control-search-filter': '\e920',
    'hc-icon--control-settings': '\e921',
    'hc-icon--control-share-android': '\e922',
    'hc-icon--control-share-ios': '\e923',
    'hc-icon--control-tools': '\e924',
    'hc-icon--player-sound-on': '\e940',
    'hc-icon--player-sound-off': '\e941',
    'hc-icon--player-back': '\e942',
    'hc-icon--player-forward': '\e943',
    'hc-icon--player-full-screen-enter': '\e944',
    'hc-icon--player-full-screen-exit': '\e945',
    'hc-icon--player-pause': '\e946',
    'hc-icon--player-play': '\e947',
    'hc-icon--player-stop': '\e948',
    'hc-icon--spend-category-business': '\e950',
    'hc-icon--spend-category-cash': '\e951',
    'hc-icon--spend-category-donation': '\e952',
    'hc-icon--spend-category-eating-out': '\e953',
    'hc-icon--spend-category-education': '\e954',
    'hc-icon--spend-category-entertainment': '\e955',
    'hc-icon--spend-category-fees-and-interest': '\e956',
    'hc-icon--spend-category-groceries': '\e957',
    'hc-icon--spend-category-health': '\e958',
    'hc-icon--spend-category-home': '\e959',
    'hc-icon--spend-category-income': '\e95a',
    'hc-icon--spend-category-money-transfer': '\e95b',
    'hc-icon--spend-category-shopping': '\e95c',
    'hc-icon--spend-category-tax-paid': '\e95d',
    'hc-icon--spend-category-transportation': '\e95e',
    'hc-icon--spend-category-travel': '\e95f',
    'hc-icon--spend-category-uncategorised': '\e960',
    'hc-icon--spend-category-utilities': '\e961',
    'hc-icon--tick': '${$hc-icon--tick}',
};
// tslint:enable object-literal-sort-keys
